var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTools(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H40V40H0z",
    transform: "translate(-533 -106) translate(528 106) translate(5)"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#2CABE0",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.795 24.783l-7.759-7.65h-1.45l-3.717 3.666v1.43l7.758 7.65c.571.562 1.493.562 2.064 0l3.104-3.06c.57-.55.57-1.473 0-2.036z",
    transform: "translate(-533 -106) translate(528 106) translate(5) translate(5 9)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.456 13.265l2.064-2.035 3.104 3.06c1.712-1.69 1.712-4.432 0-6.12L22.44 3.06l-2.064 2.035v-4.07L19.353 0 14.17 5.11l1.04 1.024h4.143L17.289 8.17 18.84 9.7l-4.23 4.17-6.046-5.96V5.86L4.143 1.501 0 5.586l4.436 4.373H6.5l6.046 5.962-1.245 1.226H8.198l-7.759 7.65c-.57.563-.57 1.473 0 2.036l3.104 3.06c.57.562 1.493.562 2.064 0l7.758-7.65v-3.06l7.54-7.434 1.551 1.516z",
    transform: "translate(-533 -106) translate(528 106) translate(5) translate(5 9)"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTools);
export default __webpack_public_path__ + "static/media/tools.aa6da114e71cf0f98106e7c6669c8ff6.svg";
export { ForwardRef as ReactComponent };